import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/esm/taggedTemplateLiteralLoose";

function _templateObject3() {
  var data = _taggedTemplateLiteralLoose(["\n\t&:active {\n\t\tuser-select: none;\n\t}\n"]);

  _templateObject3 = function () {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteralLoose(["\n\tposition: relative;\n"]);

  _templateObject2 = function () {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteralLoose(["\n\tdisplay: block !important;\n\toverflow: hidden;\n\twill-change: height;\n"]);

  _templateObject = function () {
    return data;
  };

  return data;
}

import { css } from '@wp-g2/styles';
export var CollapsibleContent = css(_templateObject());
export var innerContent = css(_templateObject2());
export var CollapsibleTrigger = css(_templateObject3());